import { UPDATE_MINI_CART_FLAG } from './types';

export const updateMiniCartFlagAction = (updateMiniCartFlag) => dispatch => {
    dispatch({
        type: UPDATE_MINI_CART_FLAG,
        updateMiniCartFlag: updateMiniCartFlag,
    })
}